import Layout from "../include/layout";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import Swal from "sweetalert2";
import { checkAuthenticate } from "../app/providers/authSlice";
import "datatables.net-bs5";
import CivilitesService from "./CivilitesService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Form, Modal } from "react-bootstrap";
import Filarial from "../include/filarial";
import Joi from "joi-browser";
import CustomAddModal from "../../components/CustomAddModal";
import CustomEditModal from "../../components/CustomEditModal";

export default function CivilitesIndex() {
  const activeLink = "CIVILITES"

  const token = useSelector((state) => state.auth.token);
  const [civilites, setCivilites] = useState([]);
  const navigate = useNavigate();
  //check if user is authenticated
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticate);
  const [errors, setErrors] = useState({});

  const [isVisible, setIsVisible] = useState(false);
  const [editModal, setEditModal] = useState(false);

  const [addFormData, setAddFormData] = useState({
    libelleCivilite: '',
    descriptionCivilite: '',
  });

  //declaration des variables pour le form d'edition
  const [editFormData, setEditFormData] = useState({
    libelleCivilite: '',
    descriptionCivilite: '',
    id: ''
  });

  //####GESTION DES REGLES DE VALIDATIONS ###########///
  const schemaAddData = {
    libelleCivilite: Joi.string().min(2).max(100).required("").empty('').options({
      language: {
        any: { required: 'le champ est obligatoire' },
        string: { min: "minimum 2 caractères", max: "maximum 100" },
      },
    }).label("Libelle"),

    descriptionCivilite: Joi.string().min(0).max(1000).empty('').options({
      language: {
        string: { max: "maximum 1000" },
      },
    }).label("Description")
  };

  //GESTION DES REGLES POUR LES FORMULAIRES D'EDITION
  const schemaEditData = {
    libelleCivilite: Joi.string().min(2).max(100).required("").empty('').options({
      language: {
        any: { required: 'le champ est obligatoire' },
        string: { min: "minimum 2 caractères", max: "maximum 100" },
      },
    }).label("Libelle"),

    descriptionCivilite: Joi.string().min(0).max(1000).empty('').options({
      language: {
        string: { max: "maximum 1000" },
      },
    }).label("Description"),

    id: Joi.number().min(1).empty('').options({
      language: {
        string: { min: "minimum 1" },
      },
    }).label("Id")
  };

  //####END GESTION DES REGLES DE VALIDATIONS ###########///


  //Gérer les changements sur les formulaires d'ajout
  const handleChange = (event) => {
    //console.log(name)
    const { name, value } = event.target;

    setAddFormData({ ...addFormData, [name]: value });

    let errorData = { ...errors };
    const errorMessage = validateProperty(event);
    //En cas d'erreur les afficher
    if (errorMessage) {
      errorData[name] = errorMessage;
    } else {
      //Sinon supprimer l'erreur existant
      delete errorData[name];
    }

    let customerData = { ...addFormData };
    customerData[name] = event.target.value;
    setAddFormData(customerData);
    setErrors(errorData);

  }


  //Vérifie si la règle de validation est validé ou pas
  const validateProperty = (event) => {
    const { name, value } = event.target;
    const obj = { [name]: value };
    const subSchema = { [name]: schemaAddData[name] };
    const result = Joi.validate(obj, subSchema);
    const { error } = result;
    return error ? error.details[0].message : null;
  };

  //Une fonction pour vider les champs du formulaire
  const clearForm = () => {
    setAddFormData({
      libelleCivilite: "",
      descriptionCivilite: "",
    });
  };

  //get liste civilités
  const fetchCivilites = async () => {
    await CivilitesService.index(token).then((res) => {
      //console.log(res.data.data)
      setCivilites(res.data.data.civilites);
    })
      .catch((error) => {
        console.log(error);
      });

    //initialize datatable
    $(document).ready(function () {
      $(".data-table").DataTable();
    });
  };

  //Gérer les changements sur les formulaires de modification
  const handleEditChange = (event) => {
    const { name, value } = event.target;
    setEditFormData({ ...editFormData, [name]: value });
    //console.log(editFormData)
    let errorData = { ...errors };
    const errorMessage = validateEditProperty(event);
    //En cas d'erreur les afficher
    if (errorMessage) {
      errorData[name] = errorMessage;
    } else {
      //Sinon supprimer l'erreur existant
      delete errorData[name];
    }

    let customerData = { ...editFormData };
    customerData[name] = event.target.value;
    setEditFormData(customerData);
    setErrors(errorData);

  }


  //Vérifie si la règle de validation est validé ou pas
  const validateEditProperty = (event) => {
    const { name, value } = event.target;
    const obj = { [name]: value };
    const subSchema = { [name]: schemaEditData[name] };
    const result = Joi.validate(obj, subSchema);
    const { error } = result;
    return error ? error.details[0].message : null;
  };


  //Enregistrer une nouvelle civilité
  const storeCivilite = async (event) => {
    event.preventDefault()
    //Check si les règles de validations sont respectées avant soumission du formulaire
    const result = Joi.validate(addFormData,
      schemaAddData, { abortEarly: false });
    //console.log(result);
    const { error } = result;
    if (error) {
      const errorData = {};
      for (let item of error.details) {
        const name = item.path[0];
        const message = item.message;
        errorData[name] = message;
      }
      //console.log(errors);
      setErrors(errorData);
      return errorData;
    } else {
      //
      await CivilitesService.store(addFormData, token).then(response => {
        //Fermer le modal
        setIsVisible(false)
        //Vider les champs du formulaire
        clearForm()
        if (response.data.status === 200) {

          Swal.fire({
            icon: "success",
            text: response.data.message,
            timer: 3000,
          });
          //Mettre à jour la liste des civilites
          fetchCivilites()
        } else {
          Swal.fire({
            icon: "error",
            text: response.data.message,
            showConfirmButton: true,
            timer: 3000,
          });

        }
      }).catch(error => {
        setIsVisible(false)
        Swal.fire({
          icon: "error",
          text: error.message,
        });
        console.log(error);
      })
    }
  }

  ///Content du modal d'ajout de civilite
  const addModalContent = (
    <Form className="needs-validation" noValidate onSubmit={storeCivilite}>
      <div className="col-md-12 mb-3">
        <Form.Label
          className="form-label fw-bold"
          htmlFor="bs-validation-name"
        >
          Libelle <i className="text-danger">*</i>
        </Form.Label>
        <Form.Control
          className="form-control"
          id="bs-validation-libelleCivilite"
          type="text"
          value={addFormData.libelleCivilite}
          onChange={handleChange}
          placeholder="Exemple : Monsieur"
          required={true}
          name="libelleCivilite"
        />

        {errors.libelleCivilite && (
          <div className="alert alert-danger">
            {errors.libelleCivilite}
          </div>
        )}
      </div>

      <div className="col-md-12 mb-2">
        <Form.Label
          className="form-label fw-bold"
          htmlFor="bs-validation-descriptionCivilite" >
          Description <i className="text-danger"></i>
        </Form.Label>
        <textarea
          className="form-control"
          id="bs-validation-descriptionCivilite"
          onChange={handleChange}
          name="descriptionCivilite"
          rows="3"
          value={addFormData.descriptionCivilite}
        ></textarea>

        {errors.descriptionCivilite && (
          <div className="alert alert-danger">
            {errors.descriptionCivilite}
          </div>
        )}
      </div>
      <Modal.Footer className="mt-4">
        <Button variant="secondary" onClick={() => setIsVisible(false)}>
          Fermer
        </Button>
        <Button variant="primary" type="submit">
          Enregistrer
        </Button>
      </Modal.Footer>
    </Form>
  );

  ///Lancer le modal d'edition
  const lauchEdit = async (id) => {
    await CivilitesService.show(id, token).then((response) => {
      const data = response.data.data;
      //console.log(response.data.data)
      setEditFormData({
        libelleCivilite: data.libelleCivilite,
        descriptionCivilite: data.descriptionCivilite,
        id: id
      })
      setEditModal(true)

    }).catch((error) => {
      Swal.fire({
        icon: "error",
        text: error.message,
      });
    });
  }

  //Modification d'une civilité
  const handleUpdate = async (event) => {
    event.preventDefault()
    //console.log("okay")
    //Check si les règles de validations sont respectées avant soumission du formulaire
    const result = Joi.validate(editFormData,
      schemaEditData, { abortEarly: false });
    //console.log(result);
    const { error } = result;
    if (error) {
      const errorData = {};
      for (let item of error.details) {
        const name = item.path[0];
        const message = item.message;
        errorData[name] = message;
      }
      //console.log(errors);
      setErrors(errorData);
      return errorData;
    } else {

      //
      await CivilitesService.update(editFormData, token).then(response => {

        //Fermer le modal
        setEditModal(false)
        if (response.data.status === 200) {

          Swal.fire({
            icon: "success",
            text: response.data.message,
            timer: 3000,
          });
          //Mettre à jour la liste des civilites
          fetchCivilites()
        } else {
          Swal.fire({
            icon: "error",
            text: response.data.message,
            showConfirmButton: true,
            timer: 3000,
          });

        }
      }).catch(error => {
        //Fermer le modal
        setEditModal(false)
        Swal.fire({
          icon: "error",
          text: error.message,
        });
        console.log(error);
      })
    }
  }

  ///Content du modal d'edition de civilite
  const editModalContent = (
    <Form className="needs-validation" noValidate onSubmit={handleUpdate}>
      <div className="row">
        <Form.Label
          className="form-label fw-bold"
          htmlFor="bs-validation-name"
        >
          Libelle <i className="text-danger">*</i>
        </Form.Label>
        <Form.Control
          className="form-control"
          id="bs-validation-libelleCivilite"
          type="text"
          value={editFormData.libelleCivilite}
          onChange={handleEditChange}
          placeholder="Exemple : ACTIF"
          required={true}
          name="libelleCivilite"
          style={{ "textTransform": "uppercase" }}
        />

        {errors.libelleCivilite && (
          <div className="alert alert-danger">
            {errors.libelleCivilite}
          </div>
        )}
      </div>

      <div className="row mb-3">
        <Form.Label
          className="form-label fw-bold"
          htmlFor="bs-validation-descriptionCivilite" >
          Description <i className="text-danger"></i>
        </Form.Label>
        <textarea
          className="form-control"
          id="bs-validation-descriptionCivilite"
          onChange={handleEditChange}
          name="descriptionCivilite"
          rows="3"
          value={editFormData.descriptionCivilite}
        ></textarea>

        {errors.descriptionCivilite && (
          <div className="alert alert-danger">
            {errors.descriptionCivilite}
          </div>
        )}

      </div>
      <Modal.Footer className="mt-4">
        <Button variant="secondary" onClick={() => setEditModal(false)}>
          Fermer
        </Button>
        <Button variant="primary" type="submit">
          Enregistrer
        </Button>
      </Modal.Footer>
    </Form>
  );


  //suppression d'un élément
  const onDelete = (param) => {
    //confirm action
    Swal.fire({
      icon: "warning",
      text: "Voulez-vous confirmer cette action ?",
      showCancelButton: true,
      cancelButtonText: "Non",
      confirmButtonText: "Oui",
      confirmButtonColor: "red",
    }).then((result) => {
      if (result.isConfirmed) {
        CivilitesService.delete(param, token).then((response) => {
          //console.log(response.data)
          if (response.data.status !== 200) {
            Swal.fire({
              icon: "error",
              text: response.data.message,
            });
          } else {
            Swal.fire({
              icon: "success",
              text: response.data.message,
            });
            fetchCivilites();
          }
        }).catch((e) => {
          Swal.fire({
            icon: "error",
            text: e.message,
          });
          console.log(e);
        });
      }
    });
  };

  useEffect(() => {
    fetchCivilites();
    // Vérifier si l'utilisateur est connecté lors du chargement de l'application
    dispatch(checkAuthenticate());
    if (!isAuthenticated) {
      //console.log(isAuthenticated)
      //Redirection sur le dashboard
      navigate(myroutes.login);
    }

  }, [dispatch]);

  return (
    <Layout>
      <div className="container-xxl flex-grow-1 container-p-y">
        <Filarial activeLink={activeLink} />

        {/* Responsive Datatable */}
        <div className="card shadow-lg mb-4 mt-2">
          <h5 className="card-header">
            Liste des civilités &nbsp;&nbsp;
            <Button className="btn btn-sm rounded-5" variant="primary" onClick={() => setIsVisible(true)} title="Ajouter">
              <FontAwesomeIcon icon="fa-solid fa-circle-plus" /></Button>
          </h5>

          <div className="card-datatable table-responsive px-4 pb-3">
            <table className="dt-responsive table border-top data-table table-hover ">
              <thead className="bg-primary">
                <tr style={{ color: "white" }}>
                  <th className="cell text-white">#</th>
                  <th className="cell text-white">Libelle</th>
                  <th className="cell text-white">Description</th>
                  <th className="cell text-white">Date modifcation</th>
                  <th className="cell text-white">Action</th>
                </tr>
              </thead>
              <tbody>
                {civilites.length > 0 &&
                  civilites.map((item, index) => (
                    <tr key={index}>
                      <td className="cell">{index + 1}</td>
                      <td className="cell">{item.libelleCivilite}</td>
                      <td className="cell">
                        <span className="truncate">{item.descriptionCivilite}</span>
                      </td>
                      <td className="cell">
                        <span>
                          {dayjs(item.updatedAt).format("DD/MM/YYYY H:m:s")}
                        </span>
                      </td>
                      <td className="cell">
                        <Button onClick={() => lauchEdit(item.id)}
                          className="btn btn-sm" severity="warning" style={{ color: "white" }}
                          title="Modifier"
                        >
                          <i className="fas fa-edit"></i>
                        </Button> &nbsp; &nbsp;
                        <Button
                          className="btn btn-sm" style={{ backgroundColor: "red", color: "white", border: "1px solid red" }}
                          onClick={() => onDelete(item.id)}
                          title="Supprimer"
                        >
                          <i className="fas fa-trash"></i>
                        </Button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
        {/*/ Responsive Datatable */}

        {/* Modal Ajout des civilites*/}
        <CustomAddModal
          modalTitle="Enregistrement civilité"
          modalContent={addModalContent}
          visible={isVisible}
          close={() => setIsVisible(false)}
        />

        {/**End Modal Ajout des civilites*/}

        {/* Modal Edition des civilites*/}
        <CustomEditModal
          modalTitle="Modification civilité"
          modalContent={editModalContent}
          visible={editModal}
          close={() => setEditModal(false)}
        />

        {/**End Modal Edition des civilites*/}

      </div>

    </Layout>
  );
}
